<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="$t('payment_links.new_link')" width="910px" class="diglog-card" @close="clearValidate('singlePaymentForm')">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('payment_links.payment_link_details') }}
      </div>
      <div class="section-tip">
        {{ $t('payment_links.tip_1') }}
      </div>
      <div class="form-container">
        <el-form ref="singlePaymentForm" :model="singlePaymentForm" status-icon label-position="top">
          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('customerService.payment_method')"
                prop="payment_type"
                :rules="[
                  { required: true, message: 'Repayment Type cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-select v-model="singlePaymentForm.payment_type" class="select-item" clearable>
                  <el-option
                    v-for="(item,index) in repaymentTypeArr"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item
                :label="$t('customerService.payment_channel')"
                prop="channel_code"
                :rules="[
                  { required: true, message: 'Channel Code cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-select v-model="singlePaymentForm.channel_code" class="select-item" clearable>
                  <el-option
                    v-for="(item,index) in channelTypeList"
                    :key="index"
                    :label="item.channel_code"
                    :value="item.channel_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('components.amount')"
                prop="amount"
                :rules="[
                  { required: isHasAmount, message: 'Amount cannot be empty', trigger: 'blur'},
                  { validator: checkAmount, trigger: 'blur' }
                ]"
              >
                <el-input v-model="singlePaymentForm.amount" type="text" class="input-item" placeholder="Enter amount" autocomplete="off" />
              </el-form-item>

            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item
                :label="$t('customerService.customer_name')"
                prop="customer_name"
                :rules="[
                  { required: singlePaymentForm.payment_type === 'Bill Payment', message: 'Customer Name cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-input v-model="singlePaymentForm.customer_name" placeholder="Enter customer name" class="search-frame" autocomplete="off" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('customerService.email_address')"
                prop="email"
                :rules="[
                  { required: singlePaymentForm.payment_type === 'Bill Payment', message: 'Email cannot be empty', trigger: 'blur'},
                  { type: 'email', message: 'Please input the correct email', trigger: ['blur', 'change'] }
                ]"
              >
                <el-input v-model.trim="singlePaymentForm.email" placeholder="Enter email address" class="search-frame" autocomplete="off" clearable />
              </el-form-item>

            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item
                :label="$t('customerService.email_content')"
                prop="email_description"
                :rules="[
                  { required: singlePaymentForm.email, message: 'Email Description cannot be empty', trigger: 'blur'},
                ]"
              >
                <template slot="label">
                  <span>{{ $t('customerService.email_content') }}</span>
                  <el-tooltip placement="top">
                    <div slot="content">
                      <span> {{ $t('tips.email_content') }}</span> <br>
                    </div>
                    <span>  <svg-icon class-name="icon-question" icon-class="icon-blue-question" class="icon-question" /></span>
                  </el-tooltip>
                </template>

                <el-input v-model="singlePaymentForm.email_description" placeholder="Enter your message" class="search-frame" autocomplete="off" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('data.remark')">
                <el-input v-model="singlePaymentForm.remark" type="textarea" autocomplete="off" placeholder="Enter your message here" />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn()">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addSinglePayment, fetchReferenceBatchNo } from '@/api/online-transaction/online-transaction.js'
import { fetchAvailableChannelList } from '@/api/components/components'
export default {
  name: 'Single_Disbursement_Edit_Modal',
  data() {
    this.checkAmount = (rule, value, callback) => {
      if (!this.isHasAmount) {
        callback()
      }
      value = Number(value)
      if (!this.$store.getters.isCurIDCountry && value > 50000) {
        return callback(new Error('Currently up to 50000'))
      }
      this.$commonFn.validateFormAmount({rule, value, callback})
      if (value > this.balance) {
        return callback(new Error('Insufficient balance!'))
      }
      callback()
    }
    return {
      channelList: [],
      repaymentTypeArr: [{ label: 'Bill Payment', value: 'Bill Payment' }, { label: 'Qrph Code', value: 'Qrph Code' }, { label: 'Bank Transfer', value: 'Bank Transfer' }],
      singlePaymentForm: {},
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      reference_batch_no: null
    }
  },
  computed: {
    isHasAmount() {
      const channelCode = this.singlePaymentForm.channel_code || ''
      return !channelCode.includes('STATIC') && !channelCode.includes('INSTA_TRANSFER_ACC')
    },
    channelTypeList() {
      const payment_type = this.singlePaymentForm.payment_type
      if (payment_type === 'Bill Payment') {
        return this.channelList.filter(item => [1].includes(item.channel_type))
      }
      if (payment_type === 'Qrph Code') {
        return this.channelList.filter(item => [5].includes(item.channel_type))
      }
      if (payment_type === 'Bank Transfer') {
        return this.channelList.filter(item => [4].includes(item.channel_type))
      }
      return []
    }

  },
  created() {
    this.getAllChannelList()
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value) {
      if (value) {
        this.getReferenceBatchNo(value)
        return
      }
      this.dialogVisible = value
    },
    getReferenceBatchNo(value) {
      fetchReferenceBatchNo().then(res => {
        if (res.code === 10000) {
          this.reference_batch_no = res.data
          this.dialogVisible = value
        }
      })
    },
    getAllChannelList() {
      fetchAvailableChannelList().then(res => {
        if (res.code === 10000) {
          this.channelList = res.data
        }
      })
    },
    clearValidate(formName) {
      this.$nextTick(function() {
        this.$refs[formName].clearValidate()
      })
    },
    onClickSubmitBtn() {
      this.$refs.singlePaymentForm.validate((valid) => {
        if (valid) {
          this.submiting = true
          const params = { ...this.singlePaymentForm }
          params.reference_batch_no = this.reference_batch_no
          if (params.customer_name) {
            params.customer_name = params.customer_name.trim()
          }

          addSinglePayment(params).then(res => {
            if (res.code === 10000) {
              this.dialogVisible = false
              this.singlePaymentForm = {}
              this.$emit('getAllReferenceInfo')
            }
          }).finally(() => {
            this.submiting = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.icon-question{
  position: relative;
  top: -1px;
  margin-left: 5px;
  font-size: 12px;
}
.select-item{
  width: 100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 500px;
  height: 40px;
  border-radius: 4px;
}
</style>
